

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { ProIndex } from '@shared/models';

	@Component({})
	export default class ProBrowse extends BaseView {


		public list: ProIndex[] = [];

		/** Fires when this component is mounted */
		public async mounted() {
			this.setTitle('Pros - SkateLurker');
			await this.refresh();
		}

		public async refresh() {
			try {
				this.loading = true;
				this.list = await this.$api.proService.index();
			} catch (err) {
				this.errorMessage = 'An error occurred while getting the results';
				this.errorHandler.handle(err, this.errorMessage);
			} finally {
				this.loading = false;
			}
		}


	}

